(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-spotlight"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="ispot-"]').forEach(function (section) {
    var stage = section.querySelector('[data-ispot-stage]');
    var frame = section.querySelector('[data-ispot-frame]');
    if (!stage) return;

    // Scroll-triggered reveal
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stage.classList.add('is-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });
    observer.observe(stage);

    // Subtle mouse-tilt on desktop (hover-capable devices only)
    if (frame && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var maxTilt = 4; // degrees

      frame.addEventListener('mousemove', function (e) {
        var rect = frame.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;   // 0 -> 1
        var y = (e.clientY - rect.top) / rect.height;   // 0 -> 1
        var rotateY = (x - 0.5) * (maxTilt * 2);
        var rotateX = (0.5 - y) * (maxTilt * 2);
        frame.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });

      frame.addEventListener('mouseleave', function () {
        frame.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trimp-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rb-banner').forEach(function (banner) {
    if (typeof Swiper === 'undefined') return;

    new Swiper(banner.querySelector('.rb-slider'), {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: banner.querySelector('.rb-pagination'),
        clickable: true,
      },
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trimp-bestseller"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.trbs-section').forEach(function (section) {

    var sliders = Array.prototype.slice.call(section.querySelectorAll('.trbs-slider-tab'));
    var prevBtn = section.querySelector('.trbs-prev');
    var nextBtn = section.querySelector('.trbs-next');

    function getActiveTrack() {
      var activeSlider = sliders.find(function (s) {
        return !s.classList.contains('trbs-slider-hidden');
      });
      return activeSlider ? activeSlider.querySelector('.trbs-track') : null;
    }

    function updateNavState(track) {
      if (!track || !prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.classList.toggle('trbs-nav-disabled', track.scrollLeft <= 0);
      nextBtn.classList.toggle('trbs-nav-disabled', track.scrollLeft >= maxScroll);
    }

    function scrollByOneCard(direction) {
      var track = getActiveTrack();
      if (!track) return;
      var slide = track.querySelector('.trbs-slide');
      if (!slide) return;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      var amount = (slide.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
      setTimeout(function () { updateNavState(track); }, 350);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOneCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOneCard(1); });

    sliders.forEach(function (sliderEl) {
      var track = sliderEl.querySelector('.trbs-track');
      if (!track) return;
      track.addEventListener('scroll', function () {
        if (!sliderEl.classList.contains('trbs-slider-hidden')) {
          updateNavState(track);
        }
      });
    });

    // initial nav state for whichever tab is active on load
    updateNavState(getActiveTrack());

    var tabBtns = section.querySelectorAll('.trbs-tab-btn');
    var headingEl = section.querySelector('.trbs-heading');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.dataset.tabIndex, 10);

        // active tab button ka class update
        tabBtns.forEach(function (b) { b.classList.remove('trbs-tab-active'); });
        btn.classList.add('trbs-tab-active');

        // sahi slider show/hide karna
        sliders.forEach(function (sliderEl, i) {
          if (i === index) {
            sliderEl.classList.remove('trbs-slider-hidden');
          } else {
            sliderEl.classList.add('trbs-slider-hidden');
          }
        });

        // naye active track ko shuru se dikhana aur nav state resync karna
        var newTrack = getActiveTrack();
        if (newTrack) {
          newTrack.scrollTo({ left: 0 });
          updateNavState(newTrack);
        }

        // heading me active collection ka title show karna
        if (headingEl) {
          headingEl.textContent = btn.textContent.trim();
        }
      });
    });



    
  
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trimp-collection-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  function initReliefSwiper() {
    if (typeof Swiper === 'undefined') {
      // Swiper script (deferred, from CDN) hasn't finished loading yet — retry shortly.
      setTimeout(initReliefSwiper, 50);
      return;
    }

    document.querySelectorAll('.relief-section').forEach(function (section) {
      var swiperEl = section.querySelector('.relief-track-wrap');
      var prevBtn = section.querySelector('.relief-arrow--prev');
      var nextBtn = section.querySelector('.relief-arrow--next');
      if (!swiperEl || swiperEl.dataset.swiperInit) return;
      swiperEl.dataset.swiperInit = 'true';

      var swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 2.5,
        spaceBetween: 12,
        watchOverflow: true,

        // Swipe / drag / scroll
        grabCursor: true,          // desktop par hand cursor
        simulateTouch: true,       // mouse drag = touch swipe
        allowTouchMove: true,
        threshold: 5,              // chhota hilne par accidental drag na ho (click safe rahe)
        touchStartPreventDefault: false,

        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true
        },

        mousewheel: {
          forceToAxis: true,       
          sensitivity: 1,
          releaseOnEdges: true     
        },

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: 'swiper-button-disabled'
        },

        breakpoints: {
          350:  { slidesPerView: 3, spaceBetween: 14 },
          480:  { slidesPerView: 4, spaceBetween: 14 },
          768:  { slidesPerView: 4, spaceBetween: 16 },
          1024: { slidesPerView: 6, spaceBetween: 24 },
          1200: { slidesPerView: 7, spaceBetween: 24 }
        }
      });


      document.addEventListener('shopify:section:load', function (e) {
        if (e.target.contains(section)) {
          swiperInstance.update();
        }
      });
    });
  }

  initReliefSwiper();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trimp-image-with-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DURATION = 1000; // ms - fast but smooth
  var alreadyRun = new WeakSet();

  function easeOutQuad(t) {
    return 1 - (1 - t) * (1 - t);
  }

  function parseTarget(raw) {
    // Splits "200k+" -> { prefix: "", number: 200, suffix: "k+" }
    // Splits "15+"   -> { prefix: "", number: 15,  suffix: "+" }
    // Splits "48"    -> { prefix: "", number: 48,  suffix: "" }
    var match = raw.match(/^([^\d]*)(\d+(?:[.,]\d+)?)([^\d]*)$/);
    if (!match) {
      return null;
    }
    return {
      prefix: match[1] || '',
      number: parseFloat(match[2].replace(',', '.')),
      decimals: (match[2].split('.')[1] || '').length,
      suffix: match[3] || ''
    };
  }

  function animateNumber(el) {
    var raw = el.getAttribute('data-count-target') || el.textContent.trim();
    var parsed = parseTarget(raw);

    if (!parsed) {
      return; // not a numeric stat, leave as-is
    }

    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / DURATION, 1);
      var eased = easeOutQuad(progress);
      var current = parsed.number * eased;

      var displayValue = parsed.decimals > 0
        ? current.toFixed(parsed.decimals)
        : Math.round(current).toString();

      el.textContent = parsed.prefix + displayValue + parsed.suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Snap to the exact original text to avoid any rounding drift
        el.textContent = raw;
      }
    }

    requestAnimationFrame(step);
  }

  function initSection(sectionEl) {
    var statsWrap = sectionEl.querySelector('[data-clinical-stats]');
    if (!statsWrap || alreadyRun.has(statsWrap)) return;

    var numbers = statsWrap.querySelectorAll('.clinical-stats__number');
    if (!numbers.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !alreadyRun.has(statsWrap)) {
          alreadyRun.add(statsWrap);
          numbers.forEach(function (numEl) {
            // Start every number visually at 0 (or "0" + suffix) before animating
            var parsed = parseTarget(numEl.getAttribute('data-count-target') || numEl.textContent.trim());
            if (parsed) {
              numEl.textContent = parsed.prefix + '0' + parsed.suffix;
            }
            animateNumber(numEl);
          });
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.35
    });

    observer.observe(statsWrap);
  }

  document.querySelectorAll('[id^="clinical-section-"]').forEach(initSection);

  // Support Shopify theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('[id^="clinical-section-"]');
    if (sectionEl) initSection(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
